import { Divider, Skeleton } from 'antd';
import ProductCardSkeleton from 'catalog/product/components/product-card/card-item.component/skeleton';
import Container from 'common/components/container.component';
import CatalogUtils from 'config/utils/catalog.util';
import React from 'react';
import { CSSProperties } from 'styled-components';
import styles from './style.module.scss';

const SearchPageSkeleton: React.FC = () => {
  //
  const renderGridSkeleton = (): React.ReactNode => {
    const childs: React.ReactNode[] = [];
    for (let index = 0; index < CatalogUtils.ITEMS_IN_SLEKELETON; index++) {
      childs.push(<ProductCardSkeleton key={index} />);
    }
    return childs;
  };

  const skeletonGridStyles: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 250px))',
    gap: '15px',
  };

  return (
    <Container>
      <div className={styles['search-page-skeleton-title']}>
        <Skeleton.Input active={true} size='default' block />
      </div>
      <Divider />
      <div style={skeletonGridStyles}>{renderGridSkeleton()}</div>
    </Container>
  );
};

export default SearchPageSkeleton;
